import {IRootState} from  "../../../redux/rootReducer";

export const planBTMapState = (state: IRootState) => ({
    planBT: state.planBT
})
